import { z } from 'zod';


const createHolidayBaseSchema = z.object({
  holidayTypeId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  date: z.string().min(1, 'attendance:holiday.validation.dateRequired'),
  reason: z.string().min(1, 'attendance:holiday.validation.reasonRequired').max(500, 'attendance:holiday.validation.reasonMaxLength'),
  nonWaivable: z.boolean().default(false),
});

export const createHolidaySchema = createHolidayBaseSchema.refine(
  (data) => data.holidayTypeId !== null,
  {
    message: 'attendance:holiday.validation.holidayTypeRequired',
    path: ['holidayTypeId'],
  },
);

export type CreateHolidayFormData = z.infer<typeof createHolidaySchema>;
